// src/pages/auth/OAuthCallback.jsx
import { Spin } from "antd";
import { useOAuthCallback } from "../../hooks/useOAuthCallback";

export default function OAuthCallback() {
  useOAuthCallback();

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    }}>
      <Spin size="large" tip="Signing you in..." />
    </div>
  );
}